<template lang='pug'>
section
  s-page-title(title='Договора' :previous='true')
  v-container(class='pa-0 mb-5' grid-list-xl fluid)
    v-layout(row wrap)
      v-flex(
        v-for='deal in deals'
        :key='deal.id'
        xs12 sm4 lg3
        class='deals-list'
      )
        card(:deal='deal' @click='showDeal')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Card from './Card'

export default {
  components: {
    Card
  },

  created() {
    this.fetchDealsList()
  },

  methods: {
    showDeal({ id, is_share }) {
      this.$router.push({
        name: 'Client.Deals.Show',
        params: { id },
        query: { is_share }
      })
    },

    ...mapActions('client/deals', ['fetchDealsList'])
  },

  computed: mapState('client/deals', ['deals'])
}
</script>

<style scoped>
.step-title {
  font-size: 18px;
  font-weight: 500;
}
.deals-list >>> .v-card {
  height: 100%;
}
</style>
